<template>
    <div>
        <!-- 顶部导航 -->
        <NavTop></NavTop>
        <!-- 隐私设置 -->
        <div class="account">
            <div class="account_m row">
                <div class="account_m_l column">
                    <div class="account_m_l_top">账号与安全中心</div>
                    <div class="account_m_l_main column">
                        <div :class="ziyuanbaohu == 1 ? 'account_m_l_main_m2' : 'account_m_l_main_m'"
                            @click="yinsibaohu(1)">账号管理</div>
                    </div>
                </div>
                <div class="account_m_r column" v-if="ziyuanbaohu == 1">
                    <div class="account_m_r_top">
                        账号管理
                        <div class="account_m_r_top_jianjie">在此可查看以及了解您账号的一些绑定设置信息</div>
                    </div>
                    <div class="account_m_r_main column">
                        <div class="account_m_r_main_shouji">
                            <div class="account_m_r_main_shouji_title">修改头像</div>
                            <div class="account_m_r_main_shouji_main row">
                                <div class="account_m_r_main_shouji_main_l">头像：</div>
                                <div class="account_m_r_main_shouji_main_touxiang">
                                    <el-upload class="avatar-uploader" :action="action" :headers="headers"
                                        :show-file-list="false" :on-success="handleAvatarSuccess"
                                        :before-upload="beforeAvatarUpload">
                                        <img v-if="info.avatarUrl" :src="info.avatarUrl" class="avatar">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        <div slot="tip" class="el-upload__tip">只能上传jpg文件，且不超过2MB</div>
                                    </el-upload>
                                </div>
                            </div>
                        </div>
                        <div class="account_m_r_main_shouji">
                            <div class="account_m_r_main_shouji_title">修改用户名</div>
                            <div class="account_m_r_main_shouji_main row">
                                <div class="account_m_r_main_shouji_main_l">用户名：</div>
                                <!-- <div class="account_m_r_main_shouji_main_r">138********</div> -->
                                <el-input class="account_m_r_main_shouji_main_r" v-model="info.nickName"></el-input>
                            </div>
                        </div>
                        <div class="account_m_r_main_shouji">
                            <div class="account_m_r_main_shouji_title">修改手机号</div>
                            <div class="account_m_r_main_shouji_main row">
                                <div class="account_m_r_main_shouji_main_l">手机号：</div>
                                <!-- <div class="account_m_r_main_shouji_main_r">138********</div> -->
                                <el-input class="account_m_r_main_shouji_main_r" v-model="info.phoneNumber"></el-input>
                            </div>
                        </div>
                        <div class="account_m_r_main_shouji">
                            <el-button class="account_m_r_main_baocun" :loading="loading"
                                @click="baocunyonghuxinxi">保存</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部 -->
        <Footer></Footer>
    </div>
</template>

<script>
import NavTop from '@/components/NavTop.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'LaAccount',
    components: { NavTop, Footer },
    data() {
        return {
            // action: process.env.VUE_APP_BASE_PROXY_URL + '/zysp/system/upload',
            action: 'https://p.lietousaas.com/saas/zysp/system/upload',
            loading: false,
            ziyuanbaohu: 1,
            info: {
                nickName: '',
                phoneNumber: '',
                avatarUrl: '',
            },
            headers: {
                'Authorization': localStorage.getItem('Authorization'),// 假设token是从Vuex或者本地存储获取
            }
        }
    },
    mounted() {
        this.info = JSON.parse(localStorage.getItem('info'));
    },
    activated() {
        // console.log(localStorage.getItem('info'));
        this.info = JSON.parse(localStorage.getItem('info'));
    },
    methods: {
        yinsibaohu(val) {
            this.ziyuanbaohu = val;
        },
        handleAvatarSuccess(res, file) {
            console.log('res, file-->', res, file);
            // this.info.avatarUrl = URL.createObjectURL(file.raw);
            if (res.data) {
                this.info.avatarUrl = res.data;
                this.postUserUpdateUrl();
            }
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        // 保存用户信息
        baocunyonghuxinxi() {
            if (this.info.nickName.trim()) {
                if (/^1[3-9]\d{9}$/.test(this.info.phoneNumber)) {
                    this.loading = true;
                    // 更新用户信息
                    this.postUserUpdate();
                } else {
                    this.$message.error('请填写正确手机号');
                }
            } else {
                this.$message.error('用户名不能为空！');
            }
        },
        // 更新用户头像信息
        async postUserUpdateUrl() {
            let res = await this.$API.postUserUpdateApi({ avatarUrl: this.info.avatarUrl });
            console.log('更新用户头像信息-->', res);
            if (res.code == 0) {
                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
        },
        // 更新用户信息
        async postUserUpdate() {
            let res = await this.$API.postUserUpdateApi({ phoneNumber: this.info.phoneNumber, nickName: this.info.nickName });
            console.log('更新用户信息-->', res);
            if (res.code == 0) {
                this.getUserInfo();
                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
            this.loading = false;
        },
        // 获取用户信息
        async getUserInfo() {
            let res = await this.$API.getUserInfoApi();
            console.log('获取用户信息-->', res);
            if (res.code == 0) {
                localStorage.setItem('info', JSON.stringify(res.data));
                this.info = res.data;
                location.reload()
            }
        }

    },
    mounted() {

    }

}
</script>
<style scoped>
.account {
    max-width: 1200px;
    min-height: 700px;
    margin: 20px auto -20px;
}

.account_m {
    min-height: 700px;
    justify-content: space-between;
}

.account_m_l {
    width: 220px;
    background: #fff;
    text-align: center;
    border-radius: 10px;
}

.account_m_l_top {
    background: linear-gradient(90deg, #f5fcfc, #fcfbfa);
    border-radius: 12px 12px 0 0;
    font-size: 20px;
    font-weight: 600;
    padding: 30px 0;
    color: #222;
    padding-left: 40px;
    text-align: left;
}

.account_m_l_main {}

.account_m_l_main_m {
    height: 62px;
    width: 100%;
    line-height: 62px;
    font-weight: 500;
    color: #666;
    cursor: pointer;
    font-size: 16px;
    margin: 0;
    padding-left: 40px;
    text-align: left;
    transition: all .3s;
}

.account_m_l_main_m2 {
    background-color: #00b2771a;
    font-weight: 600;
    color: #222;
    height: 62px;
    line-height: 62px;
    cursor: pointer;
    font-size: 16px;
    margin: 0;
    padding-left: 40px;
    text-align: left;
    transition: all .3s;
    border-left: 4px solid #00b277;
}


.account_m_r {
    background-color: #fff;
    min-height: 100%;
    border-radius: 10px;
    flex: 1;
    margin-left: 5px;
    padding: 0 60px;
}

.account_m_r_top {
    padding-top: 30px;
    padding-bottom: 24px;
    font-size: 20px;
    font-weight: 600;
    color: #222;
    line-height: 28px;
    border-bottom: 1px solid #e6e6e6;
}

.account_m_r_top_jianjie {
    color: #666;
    font-size: 13px;
    margin-top: 8px;
    font-weight: 400;
}

.account_m_r_main {
    padding: 20px 0;
}

.account_m_r_main_shouji {}

.account_m_r_main_shouji_title {
    margin: 10px 0 6px;
    font-size: 16px;
    font-weight: 600;
    color: #222;
}

.account_m_r_main_shouji_main {
    margin-top: 20px;
    margin-bottom: 24px;
    align-items: center;
}

.account_m_r_main_shouji_main_l {
    font-size: 14px;
    color: #666;
}

.account_m_r_main_shouji_main_r {
    /* color: #414a60; */
    /* padding: 8px 23px 8px 12px; */
    /* display: inline-block; */
    margin-left: 12px;
    /* background: #f8f8f8; */
    /* border-radius: 4px; */
    /* font-size: 14px; */
    /* flex: 1; */
    width: 200px;
}

.account_m_r_main_shouji_main_touxiang {
    margin-left: 12px;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #00b277;
}

.avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border-radius: 50%;
}

.avatar {
    width: 100px;
    height: 100px;
    display: block;
    border-radius: 50%;
}

.account_m_r_main_baocun {
    margin-top: 40px;
    width: 100%;
}
</style>
